import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, commons, FixedDropDownButton, Icon, modal} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, DropdownItem, Row} from "reactstrap";
const {sinkEvent} = commons;
import KartaForm from "../forms/KartaForm";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import * as subjektActions from "../actions/subjektActions";
import KartaDetail from "./KartaDetail";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující seznam karet.
 */
class KartyPanel extends Component<WithTranslation> {

    static propTypes = {
        kartyList: PropTypes.array.isRequired, // seznam karet
        // Společnost použitá při zakládání nových karet. Pokud není předána, nebudou dostupné akce pro vytvoření
        // a editaci karet a místo editačního formuláře se bude zobrazovat pouze detail karty
        spolecnost: PropTypes.object,
        readOnly: PropTypes.bool, // zda nezobrazit akce pro editaci/zakládání nových karet, implicitně true
    };

    static defaultProps = {
        readOnly: true,
    };

    handleCreateKarta = () => {
        const {spolecnost, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            KartaForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.createKarta(data, spolecnost.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateKartySpolecnosti());
                    dispatch(subjektActions.invalidateKartyUzivatel())
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {spolecnost: spolecnost}
            },
            t('new_card'),
            {size: "sm"}
        ));
    };

    handleEditKarta = (karta) => {
        const {spolecnost, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            KartaForm,
            {
                onSubmit: (data) => {
                    return SubjektApi.updateKarta(data, spolecnost.id, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(subjektActions.invalidateKartySpolecnosti());
                    dispatch(subjektActions.invalidateKartyUzivatel())
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: karta
            },
            t('edit_card'),
            {size: "sm"}
        ));
    };

    handleShowKarta = (karta) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            KartaDetail,
            {karta},
            t('card_detail', {number: karta.cisloKarta}),
            {size: "md"}
        ));
    };

    renderActions = () => {
        const {t} = this.props;
        return <ButtonToolbar>
            <Button onClick={this.handleCreateKarta}>{t('new_f')}</Button>
        </ButtonToolbar>
    };

    renderContextMenu = (karta) => {
        const {spolecnost, readOnly, t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleShowKarta.bind(this, karta))}>{t('show_detail')}</DropdownItem>
            {spolecnost && !readOnly && <DropdownItem key="1" onClick={sinkEvent(this.handleEditKarta.bind(this, karta))}>{t('edit')}</DropdownItem>}
        </FixedDropDownButton>
    };

    render() {
        const {kartyList, spolecnost, readOnly, t} = this.props;
        return <Card className="karty-panel">
            <CardHeader>
                <ActionsRow actions={spolecnost && !readOnly ? this.renderActions() : null}>
                    <h2>{t('card_many')}</h2>
                </ActionsRow>
            </CardHeader>
            <div className="items-list">
                {kartyList.length > 0 ? kartyList.map(karta =>
                    <CardBody key={karta.id} className={karta.neaktivni ? "neaktivni" : ""}>
                        <ActionsRow actions={this.renderContextMenu(karta)} onClick={spolecnost && !readOnly ? this.handleEditKarta.bind(this, karta) : this.handleShowKarta.bind(this, karta)}>
                            <Row>
                                <Col>
                                    {karta.cisloKarta}
                                </Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>
                ) : <CardBody><i>{t('no_cards')}</i></CardBody>}
            </div>
        </Card>
    }
}

export default connect()(withTranslation()(KartyPanel));
